module.exports = __webpack_public_path__ + "static/media/g1-class@2x.e9b63ac5.png";